import { create } from "zustand";
import { devtools } from "zustand/middleware";

type TBillingOnboardingModalState = {
  currentStep: number;
  isFormSuccess: boolean;
  isModalOpen: boolean;
};

type TBillingOnboardingModalActions = {
  toggleModal: () => void;
  setCurrentStep: (step: number) => void;
  setIsFormSuccess: (isVisible: boolean) => void;
};

const initialBillingOnboardingState: TBillingOnboardingModalState = {
  currentStep: 0,
  isFormSuccess: false,
  isModalOpen: false,
};

export const useBillingOnboardingStore = create<TBillingOnboardingModalState & TBillingOnboardingModalActions>()(
  devtools((set, get) => ({
    ...initialBillingOnboardingState,
    toggleModal: () => {
      set({
        isModalOpen: !get().isModalOpen,
      });
    },
    setCurrentStep: (step) => {
      set({
        currentStep: step,
      });
    },
    setIsFormSuccess: (isFormSuccess) => {
      set({
        isFormSuccess,
      });
    },
  })),
);
